import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useSelector } from 'react-redux';
import { addFooter, addHeader, addTitles } from './TemplatePrintModals';

const CustomPrintModal2 = ({ show, handleClose, title1, title2, title3, content, copia }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const { nombre, usuario, rolActivo, roles, id } = useSelector(state => state.sesion);

    useEffect(() => {
        if (show) {
            generatePdf();
        }
    }, [show, content]);

    const generatePdf = () => {
        const doc = new jsPDF('p', 'pt', 'letter'); // Establecer tamaño de hoja a carta

        const marginLeftRight = 55; // Márgenes izquierdo y derecho
        const marginTop = 55; // Margen superior
        const marginBottom = 75; // Ajustar el margen inferior para bajar el pie de página
        const headerHeight = 60; // Altura de la cabecera

        const addWatermark = (doc) => {
            const pageHeight = doc.internal.pageSize.getHeight();
            const pageWidth = doc.internal.pageSize.getWidth();

            doc.setFontSize(72);
            doc.setTextColor(240, 240, 240); // marca de agua
            doc.setFont("helvetica", "bold");
            doc.text("COPIA", pageWidth / 2, pageHeight / 2, {
                angle: 45,
                align: 'center'
            });
        };

        // Validaciones: Asegurar que los valores no sean null o undefined
        const validTitle1 = title1 || '';
        const validTitle2 = title2 || '';
        const validTitle3 = title3 || '';

        // Inicializa el número de página
        let pageNumber = 0;

        // Draw watermark on the first page before any content if copia is true
        if (copia) {
            addWatermark(doc);
        }
        const titles = { validTitle1, validTitle2, validTitle3 };
        const margins = { marginLeftRight, marginTop, marginBottom };

        if (typeof content === 'string') {
            addHeader({ doc, pageNumber, headerHeight, marginLeftRight, marginTop });
            addTitles({ doc, titles, margins, headerHeight });
            doc.text(content, marginLeftRight, marginTop + headerHeight + 80);
            addFooter({ doc, marginLeftRight, marginBottom, nombre });
        } else {
            addHeader({ doc, pageNumber, headerHeight, marginLeftRight, marginTop });
            const startTableY = addTitles({ doc, titles, margins, headerHeight });

            // 👉 NUEVO: detectar columnas numéricas para alinearlas a la derecha
            let columnStyles = {};
            if (content && Array.isArray(content.body) && content.body.length > 0) {
                const numCols = content.body[0].length;
                for (let col = 0; col < numCols; col++) {
                    let isNumericCol = true;
                    for (let row = 0; row < content.body.length; row++) {
                        const val = content.body[row][col];

                        if (val === '' || val === null || val === undefined) continue;

                        // Normaliza: quita espacios y separadores comunes
                        const normalized = String(val)
                            .replace(/\s/g, '')
                            .replace(/\./g, '')
                            .replace(/,/g, '');

                        if (normalized === '' || isNaN(Number(normalized))) {
                            isNumericCol = false;
                            break;
                        }
                    }
                    if (isNumericCol) {
                        columnStyles[col] = {
                            halign: 'right' // Alinear números a la derecha
                        };
                    }
                }
            }

            autoTable(doc, {
                head: content.head,
                body: content.body,
                startY: startTableY, // Debajo de la cabecera y los títulos
                margin: { top: startTableY, left: marginLeftRight, right: marginLeftRight, bottom: marginBottom + 10 },
                didDrawPage: function (data) {
                    pageNumber++;
                    addHeader({ doc, pageNumber, headerHeight, marginLeftRight, marginTop });
                    if (pageNumber > 1) {
                        addTitles({ doc, titles, margins, headerHeight });
                    } // Asegurar que los títulos aparezcan en cada página
                    if (copia) addWatermark(doc);
                    addFooter({ doc, marginLeftRight, marginBottom, nombre });
                },
                styles: {
                    // 👉 Letra del detalle más pequeña
                    fontSize: 8,
                    lineColor: [0, 0, 0],
                    lineWidth: 0.5,
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0],
                    // si quieres, puedes dejar el encabezado un poco más grande:
                    // fontSize: 9,
                },
                bodyStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0],
                },
                // 👉 Alineación numérica
                columnStyles,
                pageBreak: 'auto',
                rowPageBreak: 'avoid'
            });
        }

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfUrl);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{title1}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {pdfUrl && (
                    <iframe src={pdfUrl} width="100%" height="500px" title="Vista previa del Recibo"></iframe>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomPrintModal2;
